import { useState } from "react";
import {
  getExtraGroupsApi,
  addExtraGroupApi,
  updateExtraGroupApi,
  deleteExtraGroupApi,
} from "../api/extras";
import { useAuth } from "./";

export function useExtraGroup() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [extraGroups, setExtraGroups] = useState(null);
  const { auth } = useAuth();

  const getExtraGroups = async () => {
    try {
      setLoading(true);
      const response = await getExtraGroupsApi();
      setLoading(false);
      setExtraGroups(response);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const addExtraGroup = async (data) => {
    try {
      setLoading(true);
      await addExtraGroupApi(data, auth.token);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const updateExtraGroup = async (id, data) => {
    try {
      setLoading(true);
      await updateExtraGroupApi(id, data, auth.token);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const deleteExtraGroup = async (id) => {
    try {
      setLoading(true);
      await deleteExtraGroupApi(id, auth.token);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  return {
    loading,
    error,
    extraGroups,
    getExtraGroups,
    addExtraGroup,
    updateExtraGroup,
    deleteExtraGroup,
  };
}
